import { useTranslation } from "react-i18next";

import { WorkdayConnectionsSection } from "../WorkdaySections";
import { LocalDateString } from "@lib/store/src/data/timeslots/apiTypes";
import { useMemoDate } from "@lib/store/src/ui/hooks/useMemoDate";

interface WorkdayConnectionsTileProps {
  selectedDate: LocalDateString;
}

export const WorkdayConnectionsTile = ({ selectedDate }: WorkdayConnectionsTileProps) => {
  const { t } = useTranslation();
  const date = useMemoDate(selectedDate);

  return (
    <div className="w-full rounded-xl border border-gray-200 bg-beige-200 p-4">
      <p className="mb-3 text-[15px] font-semibold">{t("workplace:AtTheOffice")}</p>

      <WorkdayConnectionsSection
        workday={undefined}
        date={date}
        handleClassName="bg-white border-b-0 rounded-xl"
      />
    </div>
  );
};
